import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import EmailSignUp from '../../../components/email-sign-up/email-sign-up'
import ErrorPopup from '../../../components/error-popup/error-popup'


export class EmailSignUpPage extends Component {
  render() {
    const {t, errorMessage} = this.props

    return (
      <div>
        <ErrorPopup error={t(errorMessage)} extraClasses="xs-text-center" />
        <EmailSignUp {...this.props} />
      </div>
    )
  }
}

EmailSignUpPage.propTypes = {
  errorMessage: PropTypes.string,
  t: PropTypes.func,
}

EmailSignUpPage.defaultProps = {
  errorMessage: null,
  t: PropTypes.func,
}

const mapStateToProps = (state) => ({
  ...state.app,
  ...state.auth,
  registrationError: state.registration.error,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(EmailSignUpPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/email-sign-up-page/email-sign-up-page.js